import { render } from "./UserProfilePosts.vue?vue&type=template&id=4b739de3&ts=true"
import script from "./UserProfilePosts.vue?vue&type=script&lang=ts"
export * from "./UserProfilePosts.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__